import { render } from "./ConfirmOrder.vue?vue&type=template&id=35cde184&scoped=true"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js"

import "./ConfirmOrder.vue?vue&type=style&index=0&id=35cde184&lang=scss&scoped=true"
import "./ConfirmOrder.vue?vue&type=style&index=1&id=35cde184&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35cde184"]])

export default __exports__